export default __webpack_public_path__ + "static/WhyteRegularItalic-95acec8e4dd6f90cd7ba9aafa13646fb.woff";